import React from 'react';
import {Card, Col, Row} from "antd";
import {Types} from "../../settings/Interfaces";
import {Divider} from "antd/es";


type EntitySummaryProps = {
  data: Types.Entity
}

function EntityCard(props: EntitySummaryProps) {

  return (
      <Card title={<div className={"h4 gt-font-weight-700 "}>{props.data.name}</div>}
            actions={[<div><a href={"#"}>Ver mas <i className="bi bi-three-dots"></i></a></div>]}
      >
        <Row>
          {
            props.data.states?.map((state) => {
              return (
                  <Col span={12} key={state.id}>
                    <Row gutter={[16, 0]}>
                      <Col span={6} className={"h3 gt-text-right"}>
                        {state.quantity}
                      </Col>
                      <Col flex={"auto"} className={"gt-text-left "}>
                        {state.state}
                      </Col>
                    </Row>
                  </Col>
              )
            })
          }
        </Row>
        <Row>
          {
            props.data.severity?.map((severity) => {
              return (
                  <Col span={8} key={severity.id}>
                    <div className={"h3 gt-text-center gt-d-flex-full-center"}>
                      <div className={"giro-font-title"}
                           style={{
                             border: `1px solid ${severity.color}4d`,
                             background: `linear-gradient(${severity.color}73, ${severity.color}cc, ${severity.color}73)`,
                             padding: "5px 10px"
                           }}
                      >
                        {severity.quantity}
                      </div>
                    </div>
                    <div className={"gt-text-center "}>
                      {severity.level}
                    </div>
                  </Col>
              )
            })
          }
        </Row>
        <Row>
          {
            props.data.scales?.map((scale) => {
              return (
                  <Col span={24} key={scale.id}>
                    <Row>
                      <Col span={6} className={"h3 gt-text-center"}>
                        {scale.quantity}
                      </Col>
                      <Col flex={"auto"} className={"gt-text-left  gt-d-flex-center"}>
                        Reportados en {scale.name}
                      </Col>
                      <Col flex={"40px"} className={"gt-text-center "}>
                        <div style={{
                          borderRadius: "50%",
                          border: `1px solid ${scale.color}4d`,
                          background: `linear-gradient(${scale.color}73, ${scale.color}cc, ${scale.color}73)`,
                          height: "90%",
                          width: "65%"
                        }}
                        />
                      </Col>
                    </Row>
                  </Col>
              )
            })
          }
        </Row>
        <Divider/>
        <div>
          {
            props.data.notifications.map((notification) => {
              return (
                  <Row key={notification.id}>
                    <Col span={4} className={"h5 gt-d-flex-full-center"}>
                      {notification.quantity}
                    </Col>
                    <Col span={20} className={""}>
                      {notification.text}
                    </Col>
                  </Row>
              )
            })
          }
        </div>
      </Card>
  );
}

export default EntityCard;
